import {
    ArrayModel,
    CompositeModel,
    ConfigConstants,
    CustomInjector,
    MaterialModel,
    ModelOptionsLoaderService,
    NotificationModel,
    TextModel,
} from '@evorait/pace-core';

export default class ConfirmationMaterialStockModel extends CompositeModel {
    public materialNumber: TextModel;
    public materialDescription: TextModel;
    public storageLocation: TextModel;
    public notification: NotificationModel | undefined;
    public otherStock: MaterialModel[] = [];

    public constructor(
        public consumptionList: ArrayModel<MaterialModel>,
        notificationModel: NotificationModel | undefined,
        public bootStock: MaterialModel[] = [],
    ) {
        super('ConfirmationMaterialStockModel');

        const injector = CustomInjector.getInjector();
        const modelOptionsLoader = injector.get(ModelOptionsLoaderService);

        this.notification = notificationModel;
        this.materialNumber = new TextModel('MaterialNumber');
        modelOptionsLoader.load(this.materialNumber, ConfigConstants.OTHER_STOCK_SCREEN, 'MaterialNumber');

        this.materialNumber.options = {
            ...this.materialNumber.options,
            applicationIdentifier: ConfigConstants.ApplicationIdentifier.ProductIdentifier,
        };

        this.materialDescription = new TextModel('MaterialDesc');
        this.storageLocation = new TextModel('StorageLocation');
        modelOptionsLoader.load(this.storageLocation, 'CseOtherStock', 'StorageLocation');
    }

    public get cseMaterialStocks(): MaterialModel[] {
        return [...this.bootStock, ...this.otherStock];
    }

    public updateMaterialStock(bootStock: MaterialModel[], otherStock: MaterialModel[]): void {
        this.bootStock = [...bootStock];
        this.otherStock = [...otherStock];
    }
}
